import React from 'react';
import { useAdminUsersQuery } from 'api';
import { Select, SelectProps } from 'components';

export const AdminSelect: React.FC<SelectProps> = React.memo((props) => {
  const { data = [] } = useAdminUsersQuery();

  return (
    <Select
      options={data}
      showSearch
      filterOption={(input, option) => option?.label?.toString().toLowerCase().includes(input.toLowerCase()) ?? false}
      {...props}
    />
  );
});
